  export const getColor=(categoryID,categorydataarr)=>{
        let categoryNumber = ''
        for(const key in categorydataarr){
            if(categorydataarr.hasOwnProperty(categoryID)){
                categoryNumber = categorydataarr[categoryID].split('$-')[1]

                function DecimalHexTwosComplement(decimal) {
                    var decimal = parseInt(decimal)
                    var size = 8;

                    if (decimal.length >= 0) {
                      var hexadecimal = decimal.toString(16);

                      while ((hexadecimal.length % size) != 0) {
                        hexadecimal = "" + 0 + hexadecimal;
                        var output = '';
                        output = hexadecimal ;
                        output = '#' +output.substring(2);
                      }
                      return output;
                    } else {
                      var hexadecimal = Math.abs(decimal).toString(16);
                      while ((hexadecimal.length % size) != 0) {
                        hexadecimal = "" + 0 + hexadecimal;
                      }

                      var output = '';
                      for (var i = 0; i < hexadecimal.length; i++) {
                        output += (0x0F - parseInt(hexadecimal[i], 16)).toString(16);
                      }

                      output = (0x01 + parseInt(output, 16)).toString(16);
                      output = '#'+output.substring(2);
                      return output;
                    }
                }

                var hexString = DecimalHexTwosComplement(categoryNumber)
                if(categoryID == key){
                    return hexString
                }
            }
        }
    }

    export const lettercolor=(categoryID,categorydataarr)=> {
    const bgColor = getColor(categoryID,categorydataarr);
    console.log(bgColor,"bgcolor")

    const r = parseInt(bgColor?.substr(1, 2), 16);
    const g = parseInt(bgColor?.substr(3, 2), 16);
    const b = parseInt(bgColor?.substr(5, 2), 16);

    const luminance = (r * 299 + g * 587 + b * 114) / 1000;

    return luminance > 128 ? 'black' : 'white';
}